import posts from "../data/posts";
import { formatDate } from "./Blog";

export default function Post({ slug }) {
  const post = posts.find((p) => p.slug === slug);

  return (
    <section className="py-20">
      <div className="container-narrow">
        <a href="#/blog" className="text-sm text-muted hover:text-fg transition-colors">
          ← All posts
        </a>

        {post ? (
          <article className="mt-8">
            <time className="text-sm text-muted">{formatDate(post.date)}</time>
            <h1 className="text-3xl font-semibold tracking-tight mt-2 mb-10">
              {post.title}
            </h1>
            <div className="space-y-5 leading-relaxed">
              {post.body.split(/\n\s*\n/).map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </article>
        ) : (
          <p className="mt-8 text-muted">Post not found.</p>
        )}
      </div>
    </section>
  );
}
